import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';


export function objectKeyValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const hasCapCharacter = /[^a-z0-9_]/.test(control.value);
  return hasCapCharacter ? { capCharError: 'Capital characters and special characters except underscore (_) are not allowed' } : null;
}

export function noCapCharacter(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const hasCapCharacter = /[A-Z]/.test(control.value);
  return hasCapCharacter ? { capCharError: 'Capital characters are not allowed' } : null;
}

export function notEmptyOrSpaces(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const stripped = control.value.replace(/(<([^>]+)>)/gi, '');
  const parsedText = new DOMParser().parseFromString(stripped, 'text/html');
  // console.log(control)
  // console.log(control.value && parsedText.documentElement.textContent?.trim() === ''
  // ? { emptyString: true }
  // : null
  // );
  return control.value && parsedText.documentElement.textContent?.trim() === ''
    ? { emptyString: true }
    : null;
}

export function noSpacesAllowed(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const stripped = control.value.replace(/(<([^>]+)>)/gi, '');
  const parsedText = new DOMParser().parseFromString(stripped, 'text/html');

  const noSpacesInBetween = !/\s/g.test(control.value);

  return (control.value &&
    parsedText.documentElement.textContent?.trim() === '') ||
  !noSpacesInBetween
    ? { spacesBetween: true }
    : null;
}

export function isValidURLSlug(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const matcher = new RegExp(/^[a-z0-9]+([-_]?[a-z0-9]+)*$/);
  const isValid = matcher.test(control.value);

  return isValid ? null : { slugError: 'This slug is invalid' };
}

export function isValidURLPath(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  // Full URL with protocol or www prefix
  const matcher = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/i;

  // domain or subdomain+domain without protocol (e.g. example.com or sub.example.com)
  const matcher2 = /^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  const isValid = matcher.test(control.value) || matcher2.test(control.value);
  return isValid ? null : { urlError: 'This url is invalid' };
}

export function validatePhoneNumber(control: AbstractControl): ValidationErrors | null {
  const phoneNumber: string = control.value;
  if (phoneNumber === '' || phoneNumber === null || phoneNumber === undefined) {
    control.setErrors(null);
    return null;
  }

  const digitsOnly: string = phoneNumber.replace(/\D/g, '');
  if (digitsOnly.length !== 10 || digitsOnly.startsWith('1')) {
    control.setErrors({ invalidPhone: true });
    control.markAsTouched();
    return { invalidPhone: true };
  } else {
    control.setErrors(null);
    return null;
  }
}

export function isJsonValid(control: AbstractControl) {
  let possibleJson = control.value;
  if (possibleJson !== null) {
    possibleJson = possibleJson.trim();
  }
  if (
    possibleJson === '' ||
    possibleJson === null ||
    possibleJson === 'null' ||
    possibleJson === '{}'
  ) {
    control.setErrors(null);
    return;
  }

  if (!/^\{.*\}$/.test(possibleJson)) {
    control.setErrors({ notJson: true });
    return;
  }
  try {
    JSON.parse(possibleJson);
    control.setErrors(null);
    return;
  } catch (error) {
    control.setErrors({ notJson: true });
    return;
  }


}


export function isValidPassword(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }


  const passwordMatcher = control.value ?? '';
  const matcher = new RegExp(
    '(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()-_=+{};:,<.>])(?=.*[0-9]).*'
  );

  const isValid = matcher.test(passwordMatcher);
  return isValid ? null : { invalidPassword: 'The password format is invalid.' };
}


export function passwordMatchValidator(comparedTo :string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.parent?.get(comparedTo)?.value;
    const confirmPassword = control.value;
    if (!password || !confirmPassword) {
      return null;
    }
    return password === confirmPassword ? null : { notamatch: true };
  };
}

// export function isJsonValid(control: AbstractControl): ValidationErrors | null {
//   let possibleJson = control.value;
//   if (possibleJson !== null) {
//     possibleJson = possibleJson.trim();
//   }
//   if (
//     possibleJson === '' ||
//     possibleJson === null ||
//     possibleJson === 'null' ||
//     possibleJson === '{}'
//   ) {
//     return null;
//   }

//   if (!/^\{.*\}$/.test(possibleJson)) {
//     return { notJson: true };
//   }
//   try {
//     JSON.parse(possibleJson);
//     return null;
//   } catch (error) {
//     return { notJson: true };
//   }
// }

export function validateCreditCard(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const creditCardPattern = /^[0-9]{15,16}$/;

  const isValid = creditCardPattern.test(control.value);

  return isValid ? null : { invalidCreditCard: 'Credit card number must be 15 or 16 digits.' };
}

/**
 * Validates a credit card expiration date in MM/YY format.
 * - Month must be exactly 2 digits and a valid month value (01-12).
 * - Year must be exactly 2 digits and a valid year value
 *   (greater than last year and less than 20 years from now).
 * - Only digits are allowed (an optional single "/" separator between month and year).
 */
export function validateExpirationDate(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  // Only digits are allowed, with an optional single "/" separator (MM/YY or MMYY).
  const match = String(control.value).match(/^(\d{2})\/?(\d{2})$/);
  if (!match) {
    return { invalidExpirationDate: 'Expiration date must be a valid MM/YY value.' };
  }

  const month = Number(match[1]);
  const year = Number(match[2]);

  // Month must be a valid 2-digit month value (01-12).
  if (month < 1 || month > 12) {
    return { invalidExpirationMonth: 'Expiration month must be between 01 and 12.' };
  }

  // Year must be a valid 2-digit year: greater than last year and less than 20 years from now.
  const currentYear = new Date().getFullYear();
  const fullYear = 2000 + year;
  const lastYear = currentYear - 1;
  const maxYear = currentYear + 20;
  if (fullYear <= lastYear || fullYear > maxYear) {
    return { invalidExpirationYear: 'Expiration year must be a valid future year.' };
  }

  return null;
}

export function conditionalRequiredValidator(
  dependentControlKeys: string[],
  formGroup: FormGroup<any>
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dependentHasValue = dependentControlKeys.some(key => {
      const dependentControl = formGroup.get(key);
      // Consider a control as "filled" if its value is truthy.
      return !!dependentControl?.value;
    });
    // If a dependent control has a value, require that this control is filled.
    if (dependentHasValue) {
      return Validators.required(control);
    }
    return null;
  };
}


export function isServiceEmail(email: string): boolean {
  if (!email) return false;
  return /^service\+[^@]+@suretybondsdirect\.com$/.test(email);
}

export function isValidURL(url: string): boolean {
  if (!url) {
    return false;
  }
  const urlPattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
  return urlPattern.test(url);
}


